import {
  Business,
  GridView,
  Laptop,
  Message,
  NoteAltOutlined,
  People,
  PlaylistAddCheck,
  Settings,
  TextSnippetOutlined,
  ViewTimelineOutlined,
} from "@mui/icons-material";
import { paths } from "@rms-types/constants/paths";

import { MainSidebarItem } from "@/layouts/types";

export const SIDEBAR_MENU_ITEMS: MainSidebarItem[] = [
  {
    label: "Dashboard",
    identifier: "dashboard",
    icon: Laptop,
    link: paths.app.dashboard.getLink(),
    permissions: paths.app.dashboard.permissions,
  },
  {
    label: "Intakes",
    identifier: "intakes",
    icon: NoteAltOutlined,
    link: paths.app.intakes.getLink(),
    permissions: paths.app.intakes.permissions,
    getSubItems: ({ dashboardSidebarState }) => dashboardSidebarState.enrollmentSidebar.listItems,
    getCount: ({ sidebarCount }) => sidebarCount.intakes,
    showSearch: true,
  },
  {
    label: "Applicant Portals",
    identifier: "applicant-portals",
    icon: GridView,
    link: paths.app.applicationPortals.getLink(),
    permissions: paths.app.applicationPortals.permissions,
  },
  {
    label: "Queue",
    identifier: "queue",
    icon: TextSnippetOutlined,
    link: paths.app.queue.getLink(),
    permissions: paths.app.queue.permissions,
    getSubItems: ({ dashboardSidebarState }) => dashboardSidebarState.applicationSidebar.listItems,
    getCount: ({ sidebarCount }) => sidebarCount.queues,
    showSearch: true,
  },
  {
    label: "Workload",
    identifier: "workload",
    icon: ViewTimelineOutlined,
    link: paths.app.workload.getLink(),
    permissions: paths.app.workload.permissions,
  },
  {
    label: "Users",
    identifier: "users",
    icon: People,
    link: paths.app.userManagement.getLink(),
    permissions: paths.app.userManagement.permissions,
    subItems: [
      {
        label: "Users",
        identifier: "user-management-users",
        link: paths.app.userManagement.users.getLink(),
        permissions: paths.app.userManagement.users.permissions,
      },
      {
        label: "Roles",
        identifier: "user-management-roles",
        link: paths.app.userManagement.roles.getLink(),
        permissions: paths.app.userManagement.roles.permissions,
      },
      {
        label: "Departments",
        identifier: "user-management-departments",
        link: paths.app.userManagement.departments.getLink(),
        permissions: paths.app.userManagement.departments.permissions,
      },
    ],
  },
  {
    label: "Organizations",
    identifier: "organizations",
    icon: Business,
    link: paths.app.organizations.getLink(),
    permissions: paths.app.organizations.permissions,
    getSubItems: ({ dashboardSidebarState }) => dashboardSidebarState.organizationSidebar.listItems,
    showSearch: true,
  },
  {
    label: "Compliance",
    identifier: "compliance",
    icon: PlaylistAddCheck,
    link: paths.app.compliance.getLink(),
    permissions: paths.app.compliance.permissions,
  },
  {
    label: "Messages",
    identifier: "messages",
    icon: Message,
    link: paths.app.messages.getLink(),
    permissions: paths.app.messages.permissions,
    getCount: ({ sidebarCount }) => sidebarCount.messages,
  },
  {
    label: "Settings",
    identifier: "settings",
    icon: Settings,
    link: paths.app.settings.getLink(),
    permissions: paths.app.settings.permissions,
    subItems: [
      {
        label: "Profile",
        identifier: "settings-profile",
        link: paths.app.settings.profile.getLink(),
        permissions: paths.app.settings.profile.permissions,
      },
    ],
  },
];
